<template>
  <div class="content d-flex flex-column flex-column-fluid" id="kt_content">
    <div class="post d-flex flex-column-fluid" id="kt_post">
      <div id="kt_content_container" class="container-xxl">

        <div v-if="isLoading" class="card">
          <Loader />
        </div>
        <template v-else>
          <div class="card mb-5 mb-xxl-8">
            <div class="card-header flex-wrap border-0 pt-6 pb-0">
              <div class="card-title d-flex align-items-center gap-3">
                <button type="button" class="btn btn-sm btn-icon btn-light" @click="() => router.push({ name: 'loyalty-members' })">
                  <i class="fa fa-arrow-left"></i>
                </button>
                <h3 class="card-label mb-0">{{ member.member_number }}</h3>
              </div>
            </div>
            <div class="card-body">
              <div class="row g-5">
                <div class="col-md-3">
                  <span class="text-muted fs-7 d-block">{{ $t('loyalty.phone') }}</span>
                  <span class="fs-4 fw-bold">{{ member.phone }}</span>
                </div>
                <div class="col-md-3">
                  <span class="text-muted fs-7 d-block">{{ $t('loyalty.points_balance') }}</span>
                  <span class="fs-4 fw-bold text-primary">{{ member.points_balance }}</span>
                </div>
                <div class="col-md-3">
                  <span class="text-muted fs-7 d-block">{{ $t('loyalty.total_earned') }}</span>
                  <span class="fs-4 fw-bold text-success">{{ member.total_earned }}</span>
                </div>
                <div class="col-md-3">
                  <span class="text-muted fs-7 d-block">{{ $t('loyalty.total_redeemed') }}</span>
                  <span class="fs-4 fw-bold text-danger">{{ member.total_redeemed }}</span>
                </div>
              </div>
              <div class="mt-5">
                <span class="text-muted fs-7">{{ $t('loyalty.joined_at') }} : {{ formatDate(member.joined_at) }}</span>
              </div>
            </div>
          </div>

          <div class="card">
            <div class="card-header flex-wrap border-0 pt-6 pb-0">
              <div class="card-title"><h3 class="card-label">{{ $t('loyalty.history') }}</h3></div>
            </div>
            <div class="card-body">
              <div v-if="transactions.length === 0" class="text-muted text-center py-10">
                {{ $t('loyalty.no_history') }}
              </div>
              <table v-else class="table align-middle table-row-bordered fs-6 gy-3">
                <thead>
                  <tr class="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
                    <th class="min-w-125px">{{ $t('action') }}</th>
                    <th class="min-w-100px">{{ $t('loyalty.points') }}</th>
                    <th class="min-w-150px">{{ $t('loyalty.detail') }}</th>
                    <th class="min-w-125px">{{ $t('loyalty.shop') }}</th>
                    <th class="min-w-125px">{{ $t('loyalty.date') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="transaction in transactions" :key="transaction.id">
                    <td>
                      <span :class="transaction.type === 'earn' ? 'badge badge-light-success' : 'badge badge-light-danger'">
                        {{ transaction.type === 'earn' ? $t('loyalty.earned') : $t('loyalty.redeemed') }}
                      </span>
                    </td>
                    <td>{{ transaction.points > 0 ? '+' : '' }}{{ transaction.points }}</td>
                    <td>{{ transaction.reward ? transaction.reward.label : transaction.note }}</td>
                    <td>{{ transaction.shop ? transaction.shop.name : '-' }}</td>
                    <td>{{ formatDate(transaction.created_at) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </template>

      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import Loader from '@/components/Loader.vue'

const store = useStore()
const route = useRoute()
const router = useRouter()

const isLoading = ref(true)

const member = computed(() => store.getters['loyalty/getCurrentMember'])
const transactions = computed(() => store.getters['loyalty/getCurrentMemberTransactions'])

function formatDate(value) {
  if (!value) return ''
  return new Date(value).toLocaleString()
}

onMounted(async () => {
  await store.dispatch('loyalty/getMember', route.params.memberId)
  isLoading.value = false
})
</script>
